export default __webpack_public_path__ + "static/media/card-blog6.ee276da1.jpg";